<template>
    <div class="about-initiative-form7">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Para quais fins sua iniciativa precisa de aporte financeiro? (marque todas que se aplicam)"
                label-for="financialSupportObjetives"
                class="required"
                v-if="initiative.interesse_em_ppp.includes(11)"
            >
                <b-form-checkbox-group
                    name="financialSupportObjetives"
                    v-model="$v.form.financialSupportObjetives.selected.$model"
                    :options="getFinancialSupportOptions"
                    value-field="item"
                    text-field="text"
                    :state="validateState('financialSupportObjetives')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['fins_aporte_financeiro'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['fins_aporte_financeiro'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    :style="{ float: getProfileId === 2 ? 'left' : 'right' }"
                    v-model="form.others"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.financialSupportObjetives.selected.includes(28)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('financialSupportObjetives')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="
                        $router.push({
                            name:
                                getProfileId === 2
                                    ? 'AboutInitiativeForm5'
                                    : getProfileId === 3 && getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : getProfileId === 3 && getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : getProfileId === 3
                                    ? 'AboutInitiativeForm12'
                                    : 'AboutInitiativeForm6'
                        })
                    "
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button
                        :variant="'secondary'"
                        @click="
                            changeRegisterForm(
                                getProfileId === 2
                                    ? 'AboutInitiativeForm5'
                                    : getProfileId === 3 && getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : getProfileId === 3 && getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : getProfileId === 3
                                    ? 'AboutInitiativeForm12'
                                    : 'AboutInitiativeForm6'
                            )
                        "
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="
                            changeRegisterForm(getProfileId === 1 ? 'AboutInitiativeForm8' : 'AboutInitiativeForm9')
                        "
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()
const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        receiveFirstData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 41.55,
            message: null,
            authorizationData: null,
            isUpdate: false,
            firstInformationData: null,
            form: {
                financialSupportObjetives: {
                    selected: [],
                    options: [
                        { text: 'Ajuda de custo', item: 1, value: 1 },
                        { text: 'Estabelecimento de Endowment (Fundo Patrimonial)', item: 2, value: 2 },
                        {
                            text: 'Aluguel de Salas, Água, Luz, Internet, Domínio & Hospedagem',
                            item: 3,
                            value: 3
                        },
                        { text: 'Eventos', item: 4, value: 4 },
                        { text: 'Aquisição de Bens Imóveis', item: 5, value: 5 },
                        { text: 'Fomento de Redes', item: 6, value: 6 },
                        {
                            text: 'Aquisição de Bens Móveis (Materiais/Equipamentos, etc)',
                            item: 7,
                            value: 7
                        },
                        { text: 'Obras/Reformas', item: 8, value: 8 },
                        { text: 'Bolsa de estudo', item: 9, value: 9 },
                        {
                            text: 'Pagamento a Prestadores de Serviço com Vínculo Familiar',
                            item: 10,
                            value: 10
                        },
                        { text: 'Campanhas', item: 11, value: 11 },
                        { text: 'Pagamento de Recursos Humanos', item: 12, value: 12 },
                        { text: 'Capacitações', item: 13, value: 13 },
                        { text: 'Pagamento de Terceirizados', item: 14, value: 14 },
                        {
                            text: 'Compra de ações, debêntures ou outros valores imobiliários',
                            item: 15,
                            value: 15
                        },
                        { text: 'Pesquisas & Diagnósticos', item: 16, value: 16 },
                        { text: 'Compra de Alimentos', item: 17, value: 17 },
                        { text: 'Projetos', item: 18, value: 18 },
                        { text: 'Congressos', item: 19, value: 19 },
                        { text: 'Publicações', item: 20, value: 20 },
                        { text: 'Constituição de Fluxo de Caixa', item: 21, value: 21 },
                        {
                            text: 'Publicidade (salvo as de caráter educativo, informativo ou de orientação social)',
                            item: 22,
                            value: 22
                        },
                        { text: 'Consultorias para Estudos & Projetos', item: 23, value: 23 },
                        { text: 'Taxas Bancárias, Multas, Juros & Impostos', item: 24, value: 24 },
                        { text: 'Dívidas', item: 25, value: 26 },
                        { text: 'Viagens', item: 26, value: 26 },
                        { text: 'Não precisamos de aporte financeiro', item: 27, value: 27 },
                        { text: 'Outros (especifique)', item: 28, value: 28 }
                    ]
                },
                others: null
            }
        }
    },
    validations: {
        form: {
            financialSupportObjetives: {
                selected: {
                    required() {
                        return !(this.form.financialSupportObjetives.selected === null && this.getProfileId !== 1)
                    }
                }
            }
        }
    },
    computed: {
        getFinancialSupportOptions() {
            return this.form.financialSupportObjetives.options.filter(opt =>
                this.getProfileId === 2 ? ![27].includes(opt.item) : opt
            )
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getEditionMode() {
            return this.editionMode
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getFirstInformation() {
            return this.firstInformationData
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.financialSupportObjetives.selected =
                data.fins_aporte_financeiro === null
                    ? []
                    : data.fins_aporte_financeiro.filter(item => typeof item === 'number')

            this.form.others =
                data.fins_aporte_financeiro === null
                    ? null
                    : data.fins_aporte_financeiro.filter(item => typeof item !== 'number')[0].others

            this.firstInformationData = this.receiveFirstData
            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative(), registerFirstInformationApi.listFirst()])
                .then(response => {
                    const data = response[0].data.data
                    this.firstInformationData = response[1].data

                    if (data !== null) {
                        this.initiative = data

                        this.form.financialSupportObjetives.selected =
                            data.fins_aporte_financeiro === null
                                ? []
                                : data.fins_aporte_financeiro.filter(item => typeof item === 'number')

                        this.form.others =
                            data.fins_aporte_financeiro === null
                                ? null
                                : data.fins_aporte_financeiro.filter(item => typeof item !== 'number')[0].others
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                fins_aporte_financeiro: this.form.financialSupportObjetives.selected,
                percentual: currentProgress
            }

            data.fins_aporte_financeiro = [
                ...data.fins_aporte_financeiro,
                { others: this.form.others, specifyOthers: this.form.specifyOthers }
            ]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({
                            name: this.getProfileId === 1 ? 'AboutInitiativeForm8' : 'AboutInitiativeForm9'
                        })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.financialSupportObjetives.options = this.form.financialSupportObjetives.options.filter(x =>
                    this.form.financialSupportObjetives.selected.includes(x.value)
                )
            }
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm7-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm7.vue